/** Fired on the window when a request came back with an SoR outcome: the claim lock on the page refetches. */
export const SOR_CLAIM_LOCK_CHANGED_EVENT = 'sor-claim-lock-changed';

export const signalSorClaimLockChanged = (): void => {
  window.dispatchEvent(new Event(SOR_CLAIM_LOCK_CHANGED_EVENT));
};
